import { computed, ref } from 'vue';
import { defineStore } from 'pinia';

export const useAuth = defineStore('auth', () => {
  const token = ref(localStorage.getItem('token'));
  const userJson = localStorage.getItem('user') === null ? null : localStorage.getItem('user');
  const user = ref(userJson ? JSON.parse(userJson) : null);
  function setToken(tokenValue) {
    localStorage.setItem('token', tokenValue);
    token.value = tokenValue;
  }

  function setUser(userValue) {

    localStorage.setItem('user', JSON.stringify(userValue));
    user.value = userValue;
  }

  function isAuthenticated()
  {
    return localStorage.getItem('token') !== undefined ? true : false;
  }

  function clearToken()
  {
    localStorage.removeItem('token');
    localStorage.removeItem('user')
    user.value = '';
    token.value = '';
  } 

  const fullName = computed(() => {
    if (user.value) {
      return user.value.name + ' ' + user.value.lastname;
    }
    return '';
  });

  return {
    token,
    user,
    setToken,
    setUser,
    isAuthenticated,
    fullName,
    clearToken
  };
});